/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function($) {

  var isSlickLoaded = (typeof $.fn.slick !== 'undefined');

  var currentBreakpoint = Foundation.MediaQuery.current;

	// Adds Flex Video to YouTube and Vimeo Embeds
  jQuery('iframe[src*="youtube.com"]:not([id^="player-block"]), iframe[src*="vimeo.com"]').each(function() {
    if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
      jQuery(this).wrap("<div class='widescreen flex-video'/>");
    } else {
      jQuery(this).wrap("<div class='flex-video'/>");
    }
  });

  $('.single-mc_video iframe:not([src*="youtube.com"]):not([src*="vimeo.com"], .post-featured-video iframe:not([src*="youtube.com"]):not([src*="vimeo.com"])').each(function() {
    var imageRatio = ($(this).innerHeight() / $(this).innerWidth()) * 100;
    var wrapper = "<div class='flex-video' style='padding-bottom: " + imageRatio + "%;'/>";
    $(this).wrap(wrapper);
  });

  var mediumBreakpoint = 568;
  var largeBreakpoint = 1024;

  $("input:text").focus(function() { $(this).select(); } );
  $('input:text').mouseup(function(e) { return false; });

  $('.search-toggle').on('click', function(e) {
    e.preventDefault();
    $('.searchbar-wrapper').toggleClass('open');
    // $('.top-bar .search-field').focus();
    $('.searchbar-wrapper .search-field').focus().select();
  });
  $('.post-project-info-toggle').on('click', function(e) {
    e.preventDefault();
    $('.project-info-modal').toggleClass('open');
  });

  $( 'p:empty' ).remove();

  $('.slick-disabled').on('click', function(e) {
    e.preventDefault();
    return false;
  });

  // browser window scroll (in pixels) after which the "back to top" link is shown
  var offset = 300,
    //browser window scroll (in pixels) after which the "back to top" link opacity is reduced
    offset_opacity = 1200,
    //duration of the top scrolling animation (in ms)
    scroll_top_duration = 700,
    //grab the "back to top" link
    $back_to_top = $('.back-to-top');

  //hide or show the "back to top" link
  $(window).scroll(function(){
    ( $(this).scrollTop() > offset ) ? $back_to_top.addClass('cd-is-visible') : $back_to_top.removeClass('cd-is-visible cd-fade-out');
    if( $(this).scrollTop() > offset_opacity ) { 
      $back_to_top.addClass('cd-fade-out');
    }
  });

  //smooth scroll to top
  $back_to_top.on('click', function(event){
    event.preventDefault();
    $('body,html').animate({
      scrollTop: 0 ,
      }, scroll_top_duration
    );
  });

  var clickElem = $('.newsletter-open'); 
  clickElem.on('click', function(event) {
    event.preventDefault();
    if ( $('.newsletter-form').html().length == 0 ) {
      $.getScript('https://js.hsforms.net/forms/v2.js', function() {
          hbspt.forms.create({ 
            css: '',
            portalId: '1836195',
            formId: '12cdb99d-8c2b-4b41-883c-dc85e73645b3',
            target: '.newsletter-form', // INSERT CLASS OR ID OF DIV THAT HAS TO STORE THE FORM HERE.
            formInstanceId: '1'
          });
          $('#newsletter-modal').foundation('open');
      });
    } else {
      $('#newsletter-modal').foundation('open');
    }
  });

  if ( $('#bim-nav-magellan').length ) {
    var bimNavOffset = 60;
    if (Foundation.MediaQuery.atLeast('large')) {
      bimNavOffset = 0;
    }

    var bimNav = new Foundation.Magellan($('#bim-nav-magellan'), {
      animationEasing: 'swing',
      deepLinking: true,
      threshold: bimNavOffset,
      offset: bimNavOffset
    });

    $(window).on('changed.zf.mediaquery', function(event, newSize, oldSize) {
      if ( newSize == 'small' || newSize == 'medium') {
        bimNav.options.offset = 60;
      } else {
        bimNav.options.offset = 0;
      }
    });
  }

  if ( $('.twentytwenty-container').length ) {
    $(".twentytwenty-container").twentytwenty({
      no_overlay: true
    });
  }

  if ( $('.awards-box').length ) {
    var $awardsBox = $('.awards-box');
    $awardsBox.isotope({
      itemSelector: '.mc_award'
    });
    $('#awards-filter-group').on( 'click', '.year', function() {
      $('#awards-filter-group .year').removeClass('active');
      $(this).addClass('active');
      var filterValue = $(this).attr('data-filter');
      $awardsBox.isotope({ filter: filterValue });
    });
    // activate the default option on page load
    $('#awards-filter-group .year.active').trigger('click');
  }

  // All slick functions
  if ( isSlickLoaded ) { 
    $('.section-copy').slick({
      dots: true,
      infinite: false,
      speed: 300,
      arrows: false,
      adaptiveHeight: true
    });

    $('.project-carousel').on('init reInit beforeChange', function(event, slick, currentSlide, nextSlide){
        var i = (nextSlide ? nextSlide : 0) + 1;
        $('.slick-pagination p').text(i + ' / ' + slick.slideCount);
    });

    $('.project-carousel').slick({
      dots: false,
      infinite: false,
      speed: 300,
      prevArrow: '<div class="slick-prev"><i class="fas fa-chevron-left"></i></div>',
      nextArrow: '<div class="slick-next"><i class="fas fa-chevron-right"></i></div>'
    });

    var paginationTimer;

    function hidePagination() {
      $('.slick-pagination').removeClass('visible');
    }

    function showPagination() {
      $('.slick-pagination').addClass('visible');
      window.clearTimeout(paginationTimer);
      paginationTimer = window.setTimeout(hidePagination, 750);
    }

    $('.project-carousel').on('swipe', function(event, slick, direction){
        showPagination();
    });

    $('.project-carousel .slick-arrow').on('click', function(event) {
        showPagination();
    });

    $('.related-posts-carousel').slick({
      adaptiveHeight: true,
      dots: false,
      infinite: false,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,
      prevArrow: '<div class="slick-prev"><i class="fas fa-chevron-left"></i></div>',
      nextArrow: '<div class="slick-next"><i class="fas fa-chevron-right"></i></div>',
      responsive: [
        {
          breakpoint: largeBreakpoint,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: mediumBreakpoint,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });

    $('.related-bios-carousel').slick({
      adaptiveHeight: true,
      dots: false,
      infinite: true,
      speed: 300,
      slidesToShow: 5,
      slidesToScroll: 1,
      prevArrow: '<div class="slick-prev"><i class="fas fa-chevron-left"></i></div>',
      nextArrow: '<div class="slick-next"><i class="fas fa-chevron-right"></i></div>',
      responsive: [
        {
          breakpoint: largeBreakpoint,
          settings: {
            slidesToShow: 4
          }
        },
        {
          breakpoint: mediumBreakpoint,
          settings: {
            slidesToShow: 3
          }
        }
      ]
    });

    $('.news-terms-carousel').on('init reInit setPosition afterChange', function(event, slick, currentSlide){
        var nextSlide = $('.news-terms-carousel .slick-next');
        var nextSlideOffset = nextSlide.offset();
        var lastSlide = $('.news-terms-carousel .slick-slide:last');
        var lastSlideWidth = lastSlide.width();
        var lastSlideOffset = lastSlide.offset();
        var lastSlideRightSide = lastSlideOffset.left + lastSlideWidth;
        if ( lastSlideRightSide < nextSlideOffset.left ) {
          nextSlide.addClass('slick-disabled');
          nextSlide.attr("aria-disabled","true");
          // nextSlide.fadeOut();
        } else {
          nextSlide.removeClass('slick-disabled');
          nextSlide.attr("aria-disabled","false");
          // nextSlide.fadeIn();
        }


    });

    $('.news-terms-carousel').slick({
      dots: false,
      infinite: false,
      swipeToSlide: true,
      touchThreshold: 10,
      speed: 300,
      prevArrow: '<div class="slick-prev"><i class="fas fa-chevron-left"></i></div>',
      nextArrow: '<div class="slick-next"><i class="fas fa-chevron-right"></i></div>',
      variableWidth: true
    });

    // BIM Page
    $('.image-carousel').slick({
      dots: true,
      infinite: true,
      speed: 300,
      adaptiveHeight: true,
      prevArrow: '<div class="slick-prev"><i class="fas fa-chevron-left"></i></div>',
      nextArrow: '<div class="slick-next"><i class="fas fa-chevron-right"></i></div>'
    });

    $('.image-fader-slides').slick({
      speed: 2000,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 0,
      fade: true,
      pauseOnHover: false,
      pauseOnFocus: false,
      draggable: false,
      swipe: false
    });

    function bimTabImagesInit() {
      $('.bim-tab-images').slick({
        speed: 2000,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 0,
        fade: true,
        pauseOnHover: false,
        pauseOnFocus: false,
        draggable: false,
        swipe: false
      });
    }
    
    bimTabImagesInit();

    function bimTabImagesDestroy() {
      $('.bim-tab-images').slick('unslick');
    }

    if ( $('.bim-tabs').length ) {
      $('.bim-tabs').on('change.zf.tabs', function() {
            bimTabImagesDestroy();
            bimTabImagesInit();
       });

      $(window).on('changed.zf.mediaquery', function(event, newSize, oldSize) {
        if ( newSize == 'small' || newSize == 'medium') {
          initBimTabsSlick();
        } else {
          destroyBimTabsSlick();
        }
      });

      function initBimTabsSlick() {
        $('.bim-tabs .tabs').each(function() {
          var $tabsSlider = $(this);
          if ( $(this).hasClass('slick-initialized') ) { return true; }
          $(this).slick({
            arrows: true,
            dots: true,
            swipe: true,
            swipeToSlide: true,
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1
          });
          // $tabsSlider.find('.slick-slide').click(function() {
          //   var slideIndex = $(this).data('slick-index');
          //   $tabsSlider.slick('slickGoTo', slideIndex);
          // });
          $(this).on('beforeChange', function(event, slick, currentSlide, nextSlide){
            var clickTab = $(event.target).find('.slick-slide[data-slick-index="' + nextSlide + '"] a');
            $(event.target).foundation('selectTab', $(clickTab[0].hash));
          });
        });

      }

      if ( currentBreakpoint == 'small' || currentBreakpoint == 'medium' ) {
        initBimTabsSlick();
      }

      function destroyBimTabsSlick() {
        $('.bim-tabs .tabs').slick('unslick');
      }
    }

    if ( $('.mc-fcs-block-tabs').length ) {

      function initFCSTabsSlick() {
        $('.mc-fcs-block-tabs .tabs').each(function() {
          var $tabsSlider = $(this);
          if ( $(this).hasClass('slick-initialized') ) { return true; }
          $(this).slick({
            arrows: false,
            swipe: true,
            swipeToSlide: true,
            infinite: false,
            variableWidth: true,
            centerMode: true
          });
          $tabsSlider.find('.slick-slide').click(function() {
            var slideIndex = $(this).data('slick-index');
            $tabsSlider.slick('slickGoTo', slideIndex);
          });
        });

      }

      initFCSTabsSlick();

      function destroyFCSTabsSlick() {
        $('.mc-fcs-block-tabs .tabs').slick('unslick');
      }
    }

    $('#awards-filter-group').slick({
      arrows: false,
      swipe: true,
      swipeToSlide: true,
      infinite: false,
      variableWidth: true,
      centerMode: true
    });
    
    $('#awards-filter-group').find('.slick-slide').click(function() {
      var slideIndex = $(this).data('slick-index');
      $('#awards-filter-group').slick('slickGoTo', slideIndex);
    });
  } // End slick functions

  $(function () { objectFitImages(); }); 

  $(window).load(function() {
    $(document).trigger('resize');
    $( ".footer-testimonial.ajax" ).each(function( event ) {
      $this = $(this);
      $.ajax({
          type : 'post',
          url : WPURLS.ajaxurl,
          data : {
            action : 'mc_footer_testimonials'
          },
          beforeSend : function(){
              $this.html('<p><i class="fas fa-cog fa-spin fa-fw"></i> Loading...</p>');
          },
          success : function( response ) {
              $this.html(response);
          }
      });
    });
  });

});
